import './FAQ.css';
import { logEvent } from '../utils/logger';
import { PageHeader } from '../components/ui/Primitives';

function FAQ() {

  const event = {
    event: {
      label: 'PageView',
      data: {
        page: 'Help'
      }
    }
  }

  logEvent(event);

  return (
    <div className="page-content faq-page">
      <PageHeader eyebrow="Help center" title="Frequently asked questions" description="Everything you need to understand how Sayable answers, routes, and completes work for your callers." />
      <div className="faq-container">
        <h2>What is Sayable.ai?</h2>
        <p>Sayable.ai is an AI receptionist for inbound business calls. It answers callers, takes messages, schedules appointments, and routes calls based on the settings you configure.</p>

        <h2>Is Sayable.ai available 24/7?</h2>
        <p>Yes. Sayable is built to answer inbound calls around the clock.</p>

        <h2>How do I get started?</h2>
        <p>Choose a plan, create your account, and complete onboarding. You can optionally import details from your website, then pick a toll-free or local phone number, and customize your AI greeting, voice, and behavior.</p>

        <h2>Can I choose a local or toll-free number?</h2>
        <p>Yes. During phone number setup, you can claim either a toll-free number or search local numbers by area code.</p>

        <h2>Can I customize how the AI talks and what it says?</h2>
        <p>Yes. You can set your greeting, choose a voice, and add custom instructions for message taking, scheduling, and call transfer behavior in the Customize AI section.</p>

        {/* Support policy reviewed 2026-10-23: ChatGPT list intersected with Eleven v4 Turbo.
            https://help.openai.com/en/articles/8357869-how-to-change-your-language-setting-in-chatgpt
            https://elevenlabs.io/docs/overview/models#eleven-v4-turbo
            This uses ChatGPT's list by product decision, not a Realtime API language guarantee.
            Chinese is scoped to Mandarin; Tagalog maps to Filipino. English remains our default. */}
        <h2>Which languages does Sayable support?</h2>
        <p>Sayable officially supports the following 58 languages for caller conversations:<br /><br />Arabic, Armenian, Bengali, Bosnian, Bulgarian, Burmese, Catalan, Croatian, Czech, Danish, Dutch, English, Estonian, Filipino (Tagalog), Finnish, French, Georgian, German, Greek, Gujarati, Hindi, Hungarian, Icelandic, Indonesian, Italian, Japanese, Kannada, Kazakh, Korean, Latvian, Lithuanian, Macedonian, Malay, Malayalam, Mandarin Chinese, Marathi, Mongolian, Norwegian, Persian, Polish, Portuguese, Punjabi, Romanian, Russian, Serbian, Slovak, Slovenian, Somali, Spanish, Swahili, Swedish, Tamil, Telugu, Thai, Turkish, Ukrainian, Urdu, and Vietnamese.</p>

        <h2>Can I teach Sayable about my business?</h2>
        <p>Yes. In Knowledge, you can update business details like services, hours, location, team info, and FAQs so callers get accurate answers.</p>

        <h2>Does Sayable integrate with Google Calendar or Calendly?</h2>
        <p>Yes. Appointment scheduling supports Google Calendar and Calendly. You can connect either provider, set your availability, timezone, lead time, and meeting length, and have the AI book only within those rules.</p>

        <h2>Can I connect Google Calendar and Calendly at the same time?</h2>
        <p>No. The current setup supports one scheduling provider at a time. You can switch providers at any time. After you confirm the switch, your current calendar stays connected until the new connection succeeds. Then Sayable disconnects the previous provider.</p>

        <h2>Can Sayable send appointment confirmation texts?</h2>
        <p>Yes. When scheduling is enabled and a calendar is connected, you can turn on confirmation texts so callers can receive appointment details by SMS.</p>

        <h2>Can I route calls to team members?</h2>
        <p>Yes, on Business, Growth, and Enterprise plans. You can manage organization members and use Front Desk call routing and transfer settings. Solo focuses on message taking and scheduling.</p>

        <h2>Can I view call transcripts and notifications?</h2>
        <p>Yes. You can view, search, and manage transcripts. You can also set transcript report frequency (Never, End of Day, or As Calls Are Completed), and on non-Solo plans assign which team members receive them.</p>

        <h2>Can transcripts be deleted?</h2>
        <p>Yes. On the Transcripts page, you can open a transcript for details and remove it from your transcript list.</p>

        <h2>What plans does Sayable.ai offer?</h2>
        <p>Solo is $49/month with 100 included AI minutes. Business is $99/month with 250 minutes and team routing. Growth is $199/month with 600 minutes and expanded workflow capacity. Additional AI minutes are $0.39, $0.35, or $0.29 respectively. Enterprise plans are custom quoted. See full details on the <a href="/pricing">Pricing</a> page.</p>

        <h2>What does one subscription cover?</h2>
        <p>One subscription includes one AI receptionist configuration for one business or brand. That configuration includes its business identity, knowledge, workflows, and call routing.</p>

        <h2>Does a virtual company need a subscription for every region it serves?</h2>
        <p>No. A virtual company can serve callers across multiple cities, states, or regions with one subscription when it uses the same AI receptionist configuration. A separate subscription is needed for an independently configured business, brand, location, or receptionist.</p>

        <h2>Do you offer a free trial?</h2>
        <p>Yes. Solo, Business, and Growth include a 14-day trial with 30 AI minutes.</p>

        <h2>What happens if a subscription payment is past due?</h2>
        <p>The dashboard marks the subscription as past due and indicates the AI receptionist is offline until billing is updated through Manage Subscription.</p>

        <h2>How does Sayable.ai ensure data privacy?</h2>
        <p>Sayable.ai uses 256-bit encryption for sensitive customer data. For full details on data handling and policies, review our <a href="/privacy-policy">Privacy Policy</a>.</p>

        <h2>Is there an age requirement?</h2>
        <p>The service is not intended for people under 18, as stated in our Privacy Policy.</p>

        <div className="faq-footer">
          <p>If you have further questions, contact us at <a href="mailto:support@sayable.ai">support@sayable.ai</a>.</p>
        </div>
      </div>
    </div>

  );
}

export default FAQ;
